import auth from "@/router/auth";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

function checkSession(to, from, next) {
  if (Vue.prototype.$session.exists()) {
    auth.check().then(res => {
      NProgress.done();
      if (res) {
        next();
      } else {
        next({ path: "/login", query: { redirect: to.fullPath } });
      }
    });
  } else {
    NProgress.done();
    next({ path: "/login", query: { redirect: to.fullPath } });
  }
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: {
        path: "/404"
      }
    },
    {
      path: "/404",
      name: "NotFound",
      component: () => import(`@/pages/404.vue`)
    },
    {
      path: "/403",
      name: "AccessDenied",
      component: () => import(`@/pages/403.vue`)
    },
    {
      path: "/500",
      name: "ServerError",
      component: () => import(`@/pages/500.vue`)
    },
    {
      path: "/login",
      name: "Login",
      component: () => import(`@/pages/Login.vue`),
      beforeEnter(to, from, next) {
        if (Vue.prototype.$session.exists()) {
          auth.check().then(res => {
            NProgress.done();
            if (res) {
              const target =
                to.query.redirect && to.query.redirect.startsWith("/")
                  ? to.query.redirect
                  : "/home";
              next(target);
            } else {
              next();
            }
          });
        } else {
          NProgress.done();
          next();
        }
      }
    },
    {
      path: "/",
      name: "Root",
      redirect: {
        name: "Home"
      },
      component: () => import(`@/pages/Root.vue`),
      children: [
        {
          path: "/home",
          name: "Home",
          component: () => import(`@/pages/Home.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/cajachica",
          name: "CajaChica",
          component: () => import(`@/pages/CajaChica.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/reposicionfondo",
          name: "ReposicionFondo",
          component: () => import(`@/pages/ReposicionFondo.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/gastosviaje",
          name: "GastosViaje",
          component: () => import(`@/pages/GastosViaje.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/amex",
          name: "GastosAMEX",
          component: () => import(`@/pages/GastosAMEX.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/amex/:idsolicitud",
          name: "detalleSolicitudAMEX",
          component: () => import(`@/pages/DetalleSolicitudAMEX.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/amex/:idsolicitud_amex/comprobaciones",
          name: "ComprobacionesAMEX",
          component: () => import(`@/pages/ComprobacionesAMEX.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/amex/comprobacion/:id",
          name: "detalleComprobacionAmex",
          component: () => import(`@/pages/DetalleComprobacionAMEX.vue`),
          beforeEnter: checkSession
        },
        {
          path: "solicitudes/amex/comprobacion/:id/aprobar",
          name: "aprobarSolicitudComprobacionAmex",
          component: () => import(`@/pages/ComprobacionAmexAprobar.vue`),
          beforeEnter: checkSession
        },
        {
          path: "solicitudes/amex/comprobacion/:id/rechazar",
          name: "rechazarSolicitudComprobacionAmex",
          component: () => import(`@/pages/ComprobacionAmexRechazar.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/amex/:idsolicitud_amex/aprobar",
          name: "aprobarSolicitudAmex",
          component: () => import(`@/pages/AmexAprobar.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/amex/:idsolicitud_amex/rechazar",
          name: "rechazarSolicitudAmex",
          component: () => import(`@/pages/AmexRechazar.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/representacion/:idsolicitud/aprobar",
          name: "representacionAprobar",
          component: () => import(`@/pages/RepresentacionAprobar.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/representacion/:idsolicitud/rechazar",
          name: "representacionRechazar",
          component: () => import(`@/pages/RepresentacionRechazar.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/representacion",
          name: "GastosRepresentacion",
          component: () => import(`@/pages/GastosRepresentacion.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/representacion/:idsolicitud",
          name: "GastosRepresentacionDetalle",
          component: () => import(`@/pages/GastosRepresentacion.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/reposicion-representacion",
          name: "ReposicionRepresentacion",
          component: () => import(`@/pages/ReposicionRepresentacion.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/reposicion-representacion/:idsolicitud",
          name: "ReposicionRepresentacionDetalle",
          component: () => import(`@/pages/ReposicionRepresentacion.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/reposicion-representacion/:idsolicitud/aprobar",
          name: "representacionAprobar",
          component: () =>
            import(`@/pages/ReposicionRepresentacionAprobar.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/solicitudes/reposicion-representacion/:idsolicitud/rechazar",
          name: "representacionRechazar",
          component: () =>
            import(`@/pages/ReposicionRepresentacionRechazar.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/reportes/contabilidad",
          name: "Contabilidad",
          component: () => import(`@/pages/Contabilidad.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/reportes/resumen",
          name: "Resumen",
          component: () => import(`@/pages/Resumen.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/tesoreria",
          name: "Tesorería",
          component: () => import(`@/pages/Tesorería.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/administracion/flujosaprobacion",
          name: "FlujosAprobacion",
          component: () => import(`@/pages/FlujosAprobacion.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/administracion/procesospendientes",
          name: "ProcesosPendientes",
          component: () => import(`@/pages/ProcesosPendientes.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/administracion/catalogos",
          name: "Catalogos",
          component: () => import(`@/pages/Catalogos.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/administracion/solicitudes",
          name: "Solicitudes",
          component: () => import(`@/pages/Solicitudes.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/administracion/usuarios",
          name: "Usuarios",
          component: () => import(`@/pages/Usuarios.vue`),
          beforeEnter: checkSession
        },
        {
          path: "/notificaciones",
          name: "Notificaciones",
          component: () => import(`@/pages/Notificaciones.vue`),
          beforeEnter: checkSession
        }
      ]
    },
    {
      path: "/impresiones/detalleCajaChica",
      name: "DetalleCajaChica",
      component: () => import(`@/pages/print/DetalleCajaChica.vue`)
    },
    {
      path: "/impresiones/detalleSolicitudComprobacionAMEX",
      name: "DetalleSolicitudComprobacionAMEX",
      component: () =>
        import(`@/pages/print/DetalleSolicitudComprobacionAMEX.vue`)
    },
    {
      path: "/impresiones/detalleSolicitudAMEX",
      name: "DetalleSolicitudAMEXPrint",
      component: () =>
        import(`@/pages/print/DetalleSolicitudAMEX.vue`)
    },
    {
      path: "/impresiones/detalleSolicitudRepresentacion",
      name: "DetalleSolicitudRepresentacionPrint",
      component: () =>
        import(`@/pages/print/DetalleSolicitudRepresentacion.vue`)
    },
    {
      path: "/impresiones/detalleSolicitudComprobacionRepresentacion",
      name: "DetalleSolicitudComprobacionRepresentacion",
      component: () =>
        import(`@/pages/print/DetalleSolicitudComprobacionRepresentacion.vue`)
    },
    {
      path: "/impresiones/detalleReposicion",
      name: "DetalleReposicion",
      component: () => import(`@/pages/print/DetalleReposicion.vue`)
    },
    {
      path: "/impresiones/detalleGastosViaje",
      name: "DetalleGastosViaje",
      component: () => import(`@/pages/print/DetalleGastosViaje.vue`)
    },
    {
      path: "/admin/impresiones/detalleCajaChica",
      name: "AdminDetalleCajaChica",
      component: () => import(`@/pages/print/AdminDetalleCajaChica.vue`)
    },
    {
      path: "/admin/impresiones/detalleReposicion",
      name: "AdminDetalleReposicion",
      component: () => import(`@/pages/print/AdminDetalleReposicion.vue`)
    },
    {
      path: "/admin/impresiones/detalleGastosViaje",
      name: "AdminDetalleGastosViaje",
      component: () => import(`@/pages/print/AdminDetalleGastosViaje.vue`)
    }
  ]
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
